/* Cove Jewellery — Calendly booking widget (unpublished appointment draft) */
(() => {
  'use strict';
  const urls = {
    showroom: 'https://calendly.com/covejewellery-info/in-person-jewellery-appointment-cove-jewellery?primary_color=b76f87',
    virtual: 'https://calendly.com/covejewellery-info/virtual-jewellery-appointment-cove-jewellery?primary_color=b76f87'
  };
  let widgetLoader;
  function getCalendly() {
    if (window.Calendly && typeof window.Calendly.initInlineWidget === 'function') return Promise.resolve(window.Calendly);
    if (!widgetLoader) {
      widgetLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = () => window.Calendly && typeof window.Calendly.initInlineWidget === 'function'
          ? resolve(window.Calendly) : reject(new Error('Calendly widget unavailable'));
        script.onerror = () => reject(new Error('Calendly widget failed to load'));
        document.head.appendChild(script);
      }).catch(error => { widgetLoader = null; throw error; });
    }
    return widgetLoader;
  }
  function init(root) {
    if (root.dataset.coveCalendarReady === 'true') return;
    root.dataset.coveCalendarReady = 'true';
    const widget = root.querySelector('[data-cove-calendly-widget]');
    const choices = root.querySelectorAll('[data-cove-calendar-choice]');
    const description = root.querySelector('[data-cove-calendar-description]');
    const interest = root.querySelector('[data-cove-appointment-interest]');
    const showroomLink = root.querySelector('[data-cove-direct-showroom]');
    const virtualLink = root.querySelector('[data-cove-direct-virtual]');
    const productNotice = root.querySelector('[data-cove-product-interest]');
    const productTitle = root.querySelector('[data-cove-product-title]');
    const productLink = root.querySelector('[data-cove-product-link]');
    if (!widget || !choices.length || !interest) return;
    const params = new URLSearchParams(window.location.search);
    const referredProduct = (params.get('product') || '').trim().slice(0, 160);
    const referredPath = (params.get('item') || '').trim();
    let referredURL = '';
    if (referredPath.startsWith('/') && referredPath.includes('/products/')) {
      const parsedURL = new URL(referredPath, window.location.origin);
      if (parsedURL.origin === window.location.origin) referredURL = parsedURL.href;
    }
    if (referredProduct) {
      const specificItemOption = Array.from(interest.options).find(option => option.value === 'A particular piece or style I saw online');
      if (specificItemOption) interest.value = specificItemOption.value;
      if (productNotice && productTitle) {
        productTitle.textContent = referredProduct;
        productNotice.hidden = false;
        if (productLink) {
          productLink.hidden = !referredURL;
          if (referredURL) productLink.href = referredURL;
        }
      }
    }
    let sequence = 0;
    function render() {
      const current = root.querySelector('[data-cove-calendar-choice]:checked');
      const kind = current && current.value === 'virtual' ? 'virtual' : 'showroom';
      const interestAnswer = 'Consultation interest: ' + interest.value
        + (referredProduct ? '; Product: ' + referredProduct : '')
        + (referredURL ? '; Product link: ' + referredURL : '');
      if (showroomLink) showroomLink.href = showroomLink.href.split('?')[0] + '?a1=' + encodeURIComponent(interestAnswer);
      if (virtualLink) virtualLink.href = virtualLink.href.split('?')[0] + '?a1=' + encodeURIComponent(interestAnswer);
      const renderSequence = ++sequence;
      description.textContent = kind === 'virtual'
        ? 'Choose an available video consultation below. Calendly can show available times in your local time zone; Cove operates in Sydney.'
        : 'Choose an available time below to book your showroom visit. Our appointment schedule is based in Sydney; Calendly lets you view times in your own time zone.';
      widget.replaceChildren();
      const loading = document.createElement('p');
      loading.className = 'cove-booking__calendar-loading';
      loading.role = 'status';
      loading.textContent = 'Loading live appointment availability…';
      widget.appendChild(loading);
      getCalendly().then(calendly => {
        if (renderSequence !== sequence || !root.isConnected) return;
        widget.replaceChildren();
        calendly.initInlineWidget({url: urls[kind], parentElement: widget, resize: true, prefill: {customAnswers: {a1: interestAnswer}}});
      }).catch(() => {
        if (renderSequence !== sequence || !root.isConnected) return;
        loading.textContent = 'The live calendar could not load. Please use the direct booking link below.';
      });
    }
    choices.forEach(choice => choice.addEventListener('change', render));
    interest.addEventListener('change', render);
    render();
  }
  function initAll(scope = document) {
    if (scope.matches && scope.matches('[data-cove-booking-calendar]')) init(scope);
    scope.querySelectorAll('[data-cove-booking-calendar]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), {once:true});
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
